import { TestResultStatus } from '@y42/data-test';

const iconPath = 'assets/images/data-test-status-icons/';
const dataTestSuccess = 'data-test-success.svg';
const dataTestError = 'data-test-error.svg';

export const DataTestResultToIcon: Record<
  TestResultStatus,
  {
    label: string;
    icon: string;
  }
> = {
  [TestResultStatus.Error]: {
    label: 'Error',
    icon: `${iconPath}${dataTestError}`,
  },
  [TestResultStatus.Success]: {
    label: 'Success',
    icon: `${iconPath}${dataTestSuccess}`,
  },
};
